import { IconButton, Typography } from "@mui/material";
import { FaChevronLeft } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";

import { Container } from "../../common/Container/Container";
import { BottomNavigator } from "./components/ButtonNavigator";
import { LeftMenu } from "./components/LeftMenu";

export function PersonalBrandAmbassadorProgram() {
	const navigate = useNavigate();

	return (
		<Container navbarOrkaProps={{ white: true }} noFooter>
			<div className="resource-detail-container">
				<LeftMenu />
				<div className="main-content">
					<div className="resource-header">
						<IconButton
							className="icon-button back-button"
							onClick={() => {
								navigate("/resources");
							}}>
							<FaChevronLeft />
						</IconButton>
						<Typography className="normal-text">Back to Resources</Typography>
					</div>

					<Typography
						className="title-text bold resource-title"
						textAlign="center"
						id="introduction">
						Personal Brand Ambassador Program
					</Typography>

					<Typography className="normal-text paragraph-top">
						Yes! You're skilled. Yes! You've got knowledge and experience. Yes!
						You can bring it all. YOUR WAY.
					</Typography>

					<Typography className="normal-text paragraph-top">
						To effectively transfer your skills, knowledge, and experience, it's
						essential to define your instructional services for student success.
						That's where we come in.
					</Typography>

					<Typography className="normal-text paragraph-top">
						We'll guide you through a framework to help you plan, organize, and
						present your services creatively and effectively. Beyond providing
						essential steps for anyone teaching or coaching as a business, like
						opening training sessions or uploading educational materials, this
						step-by-step process will show you how to define your superpowers
						and translate your strongest skills into student success. Check out{" "}
						<Link to="/resources/how-to-deliver-a-great-service">
							How to deliver a great service?
						</Link>{" "}
						for more details.
					</Typography>

					<Typography className="normal-text paragraph-top">
						<span className="bold">A good first impression is everything!</span>{" "}
						When done with care, this process will elevate and promote your
						personal brand. Your goal is to build trust, so be authentic and
						honest. We’ll help you articulate your unique offerings and express
						yourself in a way that even you’ll admire.
					</Typography>

					<Typography className="normal-text paragraph-top">
						<span className="bold">And there's more!</span> We’re here as your
						biggest brand ambassador, ready to amplify your visibility to help
						you attract your BEST-FIT students and gain student enrollment.
					</Typography>

					<Typography className="normal-text paragraph-top">
						By defining your services through our framework, we can showcase
						them to your ideal students, who can message you or book with you
						directly. In business terms, this step-by-step framework is a vital
						exercise for positioning your services in the pilot training market
						and building messaging that resonates with your audience. Think of
						it as a smart digital education marketing program.
					</Typography>

					<Typography className="normal-text paragraph-top">
						<span className="bold">Why do we care so much?</span> Because we
						believe in removing biases when connecting instructors with
						students, unlike paid advertisements. Our goal is simple: to connect
						students with their best-fit instructors.
					</Typography>

					<Typography className="normal-text paragraph-top">
						If students enroll, our only ask is that all transactions remain on
						the platform so we can continue delivering innovative, tech-savvy
						services like this one.
					</Typography>

					<Typography className="normal-text paragraph-top">
						<span className="bold">Ready to spread the word?</span> Launch your
						service or course today!
					</Typography>

					<Typography className="normal-text paragraph-top">
						Go to your instructor account to{" "}
						<Link to="/training/my-services">My Services</Link>
					</Typography>

					<BottomNavigator />
				</div>
				<div className="right-menu">
					<Typography className="big-text bold">Table of Contents</Typography>
					<div className="paragraph-top">
						<Typography
							component="a"
							href="#introduction"
							className="normal-text black-text underline-on-hover-link">
							Introduction
						</Typography>
					</div>
				</div>
			</div>
		</Container>
	);
}
